import React, {useState, useEffect} from "react";
import {InputTableWrapper} from "../styles/stepper_styles.js";
//Material UI Components
import Paper from "@material-ui/core/Paper";
import Plus from "../images/plus.png";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
//devexpress
import {EditingState} from "@devexpress/dx-react-grid";
import {
  Grid,
  Table,
  TableHeaderRow,
  TableEditRow,
  TableEditColumn
} from "@devexpress/dx-react-grid-material-ui";
// Resource for styling: https://devexpress.github.io/devextreme-reactive/react/grid/docs/guides/fundamentals/

const getRowId = (row) => row.id;

//Button functional components
const AddButton = ({onExecute}) => (
  <div style={{textAlign: "center", fontColor: "#5394a9"}}>
    <Button style={{height: "20px"}} onClick={onExecute} title="Create new row">
      <img src={Plus} style={{height: "28px"}} />
    </Button>
  </div>
);

const EditButton = ({onExecute}) => (
  <IconButton onClick={onExecute} title="Edit row">
    <EditIcon />
  </IconButton>
);

const DeleteButton = ({onExecute}) => (
  <IconButton onClick={onExecute} title="Delete row">
    <DeleteIcon />
  </IconButton>
);

const CommitButton = ({onExecute}) => (
  <IconButton onClick={onExecute} title="Save changes">
    <SaveIcon />
  </IconButton>
);

const CancelButton = ({onExecute}) => (
  <IconButton color="secondary" onClick={onExecute} title="Cancel changes">
    <CancelIcon />
  </IconButton>
);

const commandComponents = {
  add: AddButton,
  edit: EditButton,
  delete: DeleteButton,
  commit: CommitButton,
  cancel: CancelButton
};

//executes commands.
const Command = ({id, onExecute}) => {
  const CommandButton = commandComponents[id];
  return <CommandButton onExecute={onExecute} />;
};

export default function EditableTable(props) {

  useEffect(() => {
    //useEffect hook sets state when new props are passed
    let orig_columns = props.columns.map((a) => Object.assign({}, a));
    let orig_rows = props.rows.map((a) => Object.assign({}, a));
    setColumns(orig_columns);
    setRows(orig_rows);
  }, [props.rows, props.columns]);

  // state initiations --> using react hooks but similar to constructor. 
  const orig_columns = props.columns.map((a) => Object.assign({}, a));
  const [columns, setColumns] = useState(orig_columns);
  const [rows, setRows] = useState(props.rows);
  const [editingRowIds, setEditingRowIds] = useState([]);
  const [addedRows, setAddedRows] = useState([]);
  const [rowChanges, setRowChanges] = useState({});

  // styles for columns.
  const [tableColumnExtensions] = useState([
    {columnName: "name", width: "25%"},
    {columnName: "description", width: "45%", wordWrapEnabled: true},
    {columnName: "price", width: "auto"},
    {columnName: "artist_name", width: "auto"},
    {columnName: "song_name", width: "auto"},
    {columnName: "genre", width: "auto"},
    {columnName: "album_name", width: "auto"},
    {columnName: "record_company", width: "auto"}
  ]);

  const headerStyling = ({...restProps}) => {
    return (
      <Table.Row
        {...restProps}
        style={{
          background:
            "linear-gradient(to right, #020d39, #012e58, #134e75, #307190, #5394a9)"
        }}
      />
    );
  };

  const cellStyling = ({...restProps}) => {
    return (
      <Table.Cell
        {...restProps}
        style={{color: "white", fontWeight: "600", fontSize: "16px"}}
      />
    );
  };

  // ====  Event functions: =====
  const changeAddedRows = (value) => {
      const initialized = value.map((row) =>
        Object.keys(row).length ? row : {default: ""}
      );
      setAddedRows(initialized);
  };

//handles all edits and updates row data in parent component.
  const commitChanges= ({added, changed, deleted}) => {
    let changedRows;
    if (added) {
        const startingAddedId =
          rows.length > 0 ? rows[rows.length - 1].id + 1 : 0;
        changedRows = [
          ...rows,
          ...added.map((row, index) => ({id: startingAddedId + index, ...row}))
        ];
      }
    if (changed) {
      changedRows = rows.map((row) =>
        changed[row.id] ? {...row, ...changed[row.id]} : row
      );
    }
    if (deleted) {
      if (rows.length === 5) {
        alert(
          "A minimum of 5 rows must be maintained, please add a row if you'd like to delete another."
        );
        return;
      }
      const deletedSet = new Set(deleted);
      changedRows = rows.filter((row) => !deletedSet.has(row.id));
    }
    props.onUpdate(changedRows);
  };

  return (
    <InputTableWrapper>
      <Paper>
        <Grid rows={rows} columns={columns} getRowId={getRowId}>
          <EditingState
            editingRowIds={editingRowIds}
            onEditingRowIdsChange={setEditingRowIds}
            rowChanges={rowChanges}
            onRowChangesChange={setRowChanges}
            addedRows={addedRows}
            onAddedRowsChange={changeAddedRows}
            onCommitChanges={commitChanges}
          />
          <Table columnExtensions={tableColumnExtensions} />
          <TableHeaderRow
            cellComponent={cellStyling}
            rowComponent={headerStyling}
          />
          <TableEditRow />
          {props.activeStep === 0 && (
            <TableEditColumn
              width={170}
              showAddCommand={!addedRows.length}
              showEditCommand
              showDeleteCommand
              commandComponent={Command}
            />
          )}
        </Grid>
      </Paper>
    </InputTableWrapper>
  );
}
